export interface Paging {
  totalItems: number;
  totalPages: number;
  page: number;
  perPage: number;
}

export interface InteractionFilter {
  label: string;
  value: string;
}

export const AGENT_ID_FILTER = 'agentId';
export const TEAM_ID_FILTER = 'teamId';
export const TEAM_MEMBER_ID_FILTER = 'teamMemberId';
